module.exports = __webpack_public_path__ + "angry.ef6c6709.png";